export default function setUpSchedule(schedule, domainId)
{
    if (!schedule || typeof schedule !== "object") {
        throw new Error("Invalid schedule: schedule must be a non-null object.");
    }

    const { type, date_start, timezone, time, name, date_end, frequency, days_of_week } = schedule;
    const baseSchedule = {
        domain_id: domainId,
        type: type,
        name: name
    };

    if (schedule.type === "one") {
        return {
            ...baseSchedule,
            choose_time: [
                {
                    date_start: date_start,
                    timezone: timezone,
                    time: time,
                },
            ],
        };
    } else if (["recurring", "tail-recurring"].includes(schedule.type)) {
        return {
            ...baseSchedule,
            time: time,
            timezone: timezone,
            date_start: date_start,
            date_end: date_end,
            frequency: frequency,
            days_of_week: days_of_week,
        };
    } else {
        throw new Error(`Unsupported schedule type: ${type}`);
    }

}